import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import NativeSelect from "@mui/material/NativeSelect";

export default function RoleDialog(props) {
  const [roleId, setRole] = React.useState(0);
  const [confId, setConf] = React.useState(0);
  const [teamId, setTeam] = React.useState(0);
  const [count, setCount] = React.useState(0);

  const {
    handleClose,
    roles_list,
    conf_list,
    dialogOpen,
    old_confId,
    old_roleId,
    needPeople = false,
    team = [],
  } = props;

  React.useEffect(() => {
    if (count == 0) {
      setConf(old_confId);
      setRole(old_roleId);
      setTeam(0);
    }
  });

  function selectRole(e) {
    setCount(count + 1);
    setRole(e);
  }

  function selectConf(e) {
    setCount(count + 1);
    setConf(e);
  }

  function selectTeam(e) {
    setCount(count + 1);
    setTeam(e);
  }

  function saveData() {
    console.log(roleId, confId);

    if (roleId > 0) {
      if (needPeople) {
        if (teamId > 0) handleClose({ roleId, confId, teamId });
      } else handleClose({ roleId, confId, teamId: 0 });

      setCount(0);
    }
  }

  function cancelData() {
    handleClose("");
    setCount(0);
  }

  return (
    <Dialog open={dialogOpen}>
      <DialogTitle>
        {old_confId == 0 ? "Добавить роль" : "Редактировать роль"}
      </DialogTitle>
      <form>
        <DialogContent>
          {needPeople && (
            <div style={{ paddingBottom: 10 }}>
              <select onChange={(e) => selectTeam(e.target.value)}>
                <option value={0} selected={roleId == 0}>
                  Выберите члена команды
                </option>
                {team.map((item, index) => (
                  <option value={item.id} selected={teamId == item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div style={{ paddingBottom: 10 }}>
            <select onChange={(e) => selectRole(e.target.value)}>
              <option value={0} selected={roleId == 0}>
                Выберите роль
              </option>
              {roles_list.map((item, index) => (
                <option value={item.id} selected={roleId == item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <span>Выберите конференцию</span>
          <select onChange={(e) => selectConf(e.target.value)}>
            <option value={0} selected={confId == 0}>
              Без конференции
            </option>
            {conf_list.map((item, index) => (
              <option value={item.id} selected={confId == item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </DialogContent>
        <DialogActions>
          <Button onClick={saveData}>Сохранить</Button>
          <Button onClick={cancelData}>Отмена</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
